<template>
  <v-container grid-list-lg px-0 py-0 fluid>
    <v-layout
      row
      wrap
      v-if="
        bid &&
          bid.package &&
          bid.package[bidServiceType] &&
          bid.package[bidServiceType].data
      "
    >
      <v-flex xs12 bid__confirm :class="{ isBlocked: bid.status !== 0 }">
        <v-layout row wrap v-if="!isClientSmallMode">
          <v-flex xs3 bid__info-title>{{ nameClientTitle }}</v-flex>
          <v-flex xs9 bid__info-content>{{
            bid.package[bidServiceType].data.customer
          }}</v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-if="
            bid.package[bidServiceType].data.customer_inn && !isClientSmallMode
          "
        >
          <v-flex xs3 bid__info-title>{{
            $t("components.bids.info.inn")
          }}</v-flex>
          <v-flex xs9 bid__info-content>{{
            bid.package[bidServiceType].data.customer_inn
          }}</v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-if="
            bid.package[bidServiceType].data.customer_address &&
              !isClientSmallMode
          "
        >
          <v-flex xs3 bid__info-title>{{ nameClientAddressTitle }}</v-flex>
          <v-flex xs9 bid__info-content>{{
            bid.package[bidServiceType].data.customer_address
          }}</v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-if="
            bid.package[bidServiceType].data.customer_region !==
              bid.package[bidServiceType].data.customer_address &&
              !isClientSmallMode
          "
        >
          <v-flex xs3 bid__info-title>{{
            bid.type === 7
              ? $t("components.bids.info.regionType7")
              : $t("components.bids.info.region")
          }}</v-flex>
          <v-flex xs9 bid__info-content>{{
            bid.package[bidServiceType].data.customer_region
          }}</v-flex>
        </v-layout>

        <v-layout row wrap v-if="!isClientSmallMode">
          <v-flex xs3 bid__info-title>{{
            bid.type === 7
              ? $t("components.bids.info.title")
              : $t("components.bids.info.titleTender")
          }}</v-flex>
          <v-flex xs9 bid__info-content>{{
            bid.package[bidServiceType].data.tender_subject
          }}</v-flex>
        </v-layout>

        <v-divider class="my-3" v-if="userRole === 170 || userRole === 100" />

        <v-layout row wrap v-if="userRole === 170 || userRole === 100">
          <v-flex xs3 bid__info-title>{{
            $t("components.bids.info.account")
          }}</v-flex>
          <v-flex xs9 bid__info-content>{{ bid.user.full_name }}</v-flex>
        </v-layout>
        <v-layout row wrap v-if="userRole === 170 || userRole === 100">
          <v-flex xs3 bid__info-title>{{
            $t("components.bids.info.phone")
          }}</v-flex>
          <v-flex xs9 bid__info-content>{{
            bid.user.phone | formatPhone
          }}</v-flex>
        </v-layout>

        <v-layout row wrap v-if="userRole === 170 || userRole === 100">
          <v-flex xs3 bid__info-title>E-mail</v-flex>
          <v-flex xs9 bid__info-content>{{ bid.user.email }}</v-flex>
        </v-layout>

        <v-divider class="my-3" v-if="!isClientSmallMode" />

        <v-layout row wrap>
          <v-flex xs12 sm6 md6>
            <v-layout row wrap v-if="bid.type !== 7 && bid.type !== 8">
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.tenderNumber")
              }}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.package[bidServiceType].data.tender_number
              }}</v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.created_at")
              }}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.created_at | formatDate
              }}</v-flex>
            </v-layout>

            <v-layout row wrap v-if="bid.type === 8">
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.date_from")
              }}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.package[bidServiceType].data.date_from | formatDate
              }}</v-flex>
            </v-layout>

            <v-layout row wrap v-if="bid.type === 8">
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.date_to")
              }}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.package[bidServiceType].data.date_to | formatDate
              }}</v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.status")
              }}</v-flex>
              <v-flex xs6 bid__info-content>
                <div
                  :class="
                    `status status__${bid.status} ${
                      bid.is_decline ? 'decline' : ''
                    }`
                  "
                >
                  {{ getStatusName(bid) }}
                </div>

                <div
                  v-if="
                    bid.status > 30 &&
                      userRole === 170 &&
                      //(bid.bankGuarantee || bid.bankKik) &&
                      bid.status !== 200
                  "
                >
                  <v-btn
                    v-if="bid.is_decline"
                    :loading="loadingDecline"
                    color="blue-grey"
                    class="override-button-color-dark"
                    @click="toggleDecline"
                    tile
                  >
                    <v-icon left dark>mdi-history</v-icon
                    >{{ $t("components.bids.info.cancelDeclineBid") }}
                  </v-btn>
                  <v-btn
                    v-else
                    :loading="loadingDecline"
                    color="red lighten-2"
                    :disabled="bid.is_archive"
                    class="override-button-color-dark"
                    @click="toggleDecline"
                    tile
                  >
                    <v-icon left dark>mdi-cancel</v-icon
                    >{{ $t("components.bids.info.declineBid") }}
                  </v-btn>
                </div>

                <div v-if="bid.status === 30 && userRole === 170">
                  <div class="bid__return-link" @click="returnBid">
                    <v-progress-circular
                      indeterminate
                      size="18"
                      width="2"
                      class="mr-1"
                      v-if="isLoaded"
                    ></v-progress-circular>
                    <v-icon color="error" size="18px" v-else>warning</v-icon>
                    <strong>{{ $t("components.bids.info.returnBid") }}</strong>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <v-layout row wrap v-if="bid.type !== 7">
              <v-flex xs6 bid__info-title>{{ initialСontractSumTitle }}</v-flex>
              <v-flex xs6 bid__info-content>
                {{
                  bid.package[bidServiceType].data.initial_contract_sum
                    | formatPrice("", 2)
                }}
                <span
                  @click="copyInitialPrice"
                  v-if="!bid.package[bidServiceType].data.actual_contract_sum"
                  >{{ $t("components.bids.info.copy") }}</span
                >
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              vv-if="bid.package[bidServiceType].data.federal_law === 44"
            >
              <v-flex xs6 bid__info-title>{{ securitySumTitle }}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.package[bidServiceType].data.security_sum
                  | formatPrice("", 2)
              }}</v-flex>
            </v-layout>

            <v-layout row wrap v-if="bid.type !== 8">
              <v-flex xs6 bid__info-title>{{
                bid.type === 6
                  ? $t("components.bids.info.deadlineLoan")
                  : $t("components.bids.info.deadline")
              }}</v-flex>
              <v-flex
                xs6
                bid__info-content
                v-if="
                  bid.type !== 5 &&
                    bid.package[bidServiceType].data.issue_deadline_date
                "
                >{{
                  bid.package[bidServiceType].data.issue_deadline_date
                    | formatDate
                }}
                ({{
                  getDateFrom(
                    bid.package[bidServiceType].data.issue_deadline_date
                  )
                }})</v-flex
              >
              <v-flex xs6 bid__info-content v-else
                >{{
                  bid.package[bidServiceType].data.credit_date_to | formatDate
                }}
                ({{
                  getDateFrom(bid.package[bidServiceType].data.credit_date_to)
                }})</v-flex
              >
            </v-layout>

            <v-layout
              row
              wrap
              v-if="bid.type !== 7"
              vv-if="bid.package[bidServiceType].data.federal_law === 44"
            >
              <v-flex xs6 bid__info-title>{{
                bid.type === 6
                  ? $t("components.bids.info.security_sum.6")
                  : $t("components.bids.info.security_sum.default")
              }}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.package[bidServiceType].data.security_sum
                  | formatPrice("", 2)
              }}</v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              v-if="
                bid.package[bidServiceType].data.has_deposit !== null &&
                  bid.type !== 7
              "
            >
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.deposit")
              }}</v-flex>
              <v-flex xs6 bid__info-content>
                <v-icon
                  color="green"
                  v-if="bid.package[bidServiceType].data.has_deposit"
                  >mdi-check</v-icon
                >
                <v-icon color="gray" v-else>mdi-minus</v-icon>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              v-if="
                /*bid.package[bidServiceType].data.federal_law === 44 &&*/
                bid.package[bidServiceType].data.date_to
              "
            >
              <v-flex xs6 bid__info-title>{{
                bid.type === 6
                  ? $t("components.bids.info.date_to_inline.6")
                  : $t("components.bids.info.date_to_inline.default")
              }}</v-flex>
              <v-flex xs6 bid__info-content v-if="bid.type < 5"
                >{{ bid.package[bidServiceType].data.date_to | formatDate }} ({{
                  serviceRange
                }}
                {{
                  $t("components.bids.info.date_to_inline.daysLeft")
                }})</v-flex
              >
              <v-flex xs6 bid__info-content v-else>
                {{ bid.package[bidServiceType].data.date_to | formatDate }}
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="bid.type === 5">
              <v-flex xs6 bid__info-title>{{
                $t("components.bids.info.creditSum.default")
              }}</v-flex>
              <v-flex xs6 bid__info-content
                >{{ bid.package[bidServiceType].data.credit_sum | formatPrice }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider class="my-3" />

        <v-layout row wrap v-if="company && company.data && !isClientSmallMode">
          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.company")}}</v-flex>
              <v-flex xs6 bid__info-content>{{
                company.data.organization_short_name
                  ? company.data.organization_short_name
                  : company.data.short_name
              }}</v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.inn")}}</v-flex>
              <v-flex xs6 bid__info-content>{{ company.data.inn }}</v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.director")}}</v-flex>
              <v-flex xs6 bid__info-content>{{
                company.data.contact_person_full_name
                  ? company.data.contact_person_full_name
                  : company.data.contact_full_name
              }}</v-flex>
            </v-layout>
            <v-layout row wrap v-if="company.data.contact_person_phone">
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.phoneCompnay")}}</v-flex>
              <v-flex xs6 bid__info-content>{{
                company.data.contact_person_phone
                  ? `${company.data.contact_person_phone}`
                  : ""
              }}</v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs6 v-if="bid.user">
            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.contactPerson")}}</v-flex>
              <v-flex xs6 bid__info-content>{{ bid.user.full_name }}</v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.contactPhone")}}</v-flex>
              <v-flex xs6 bid__info-content>{{
                bid.user.phone | formatPhone
              }}</v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 bid__info-title>{{$t("components.bids.info.contactEmail")}}</v-flex>
              <v-flex xs6 bid__info-content>{{ bid.user.email }}</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="declineDialogModel" width="555" persistent>
      <v-layout row wrap modal modal__closable bid__agreement-info>
        <span class="modal__close" @click="closeDeclineModal"></span>
        <v-flex xs12 modal__wrapper>
          <v-flex xs12>
            <v-textarea
              v-model="commentDecline"
              :label="$t('components.bids.bid.declineDialog.label')"
              outlined
            ></v-textarea>
          </v-flex>
          <div class="text-center py-5">
            <v-btn
              color="red"
              :disabled="
                commentDecline
                  ? commentDecline.trim().length > 0
                    ? false
                    : true
                  : true
              "
              @click="toggleDecline(true)"
              outlined
              >{{$t('components.bids.bid.declineDialog.submit')}}</v-btn
            >
          </div>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import { mask } from "vue-the-mask";
import formatDate from "@/mixins/filters/formatDate";
import formatPhone from "@/mixins/filters/formatPhone";
import formatPrice from "@/mixins/filters/formatPrice";
import statusNames from "@/utils/data/statuses";
import moment from "moment";
import showNotify from "@/services/noty";
import i18n from "@/services/i18n";

export default {
  name: "BidInfo",
  directives: { mask },
  mixins: [formatDate, formatPhone, formatPrice],
  data: () => ({
    bidServiceType: "bankGuarantee",
    serviceRange: null,
    statusNames,
    isLoaded: false,
    loadingDecline: false,
    declineDialogModel: false,
    commentDecline: null,
  }),
  props: {
    bid: {
      type: Object,
    },
    company: {
      type: Object,
    },
  },
  computed: {
    nameClientTitle() {
      if (this.bid) {
        if (this.bid.type === 7)
          return i18n.t("components.bids.info.clientTitle.7");
        if (this.bid.type === 8)
          return i18n.t("components.bids.info.clientTitle.8");
      }
      return i18n.t("components.bids.info.clientTitle.default");
    },
    nameClientAddressTitle() {
      if (this.bid) {
        if (this.bid.type === 7)
          return i18n.t("components.bids.info.clientAddress.7");
        if (this.bid.type === 8)
          return i18n.t("components.bids.info.clientAddress.8");
      }
      return i18n.t("components.bids.info.clientAddress.default");
    },
    securitySumTitle() {
      if (this.bid && this.bid.type === 6)
        return i18n.t("components.bids.info.security_sum.6");
      if (this.bid && this.bid.type === 8)
        return i18n.t("components.bids.info.security_sum.8");

      return i18n.t("components.bids.info.security_sum.default");
    },
    initialСontractSumTitle() {
      if (this.bid && this.bid.type === 8)
        return i18n.t("components.bids.info.initialSum.8");
      return i18n.t("components.bids.info.initialSum.default");
    },
    ...mapState({
      userRole: (state) => state.user.profile.role,
    }),

    isClientSmallMode() {
      if (this.userRole > 0 && this.userRole <= 35) {
        if (this.bid.status >= 40) return true;
      }
      return false;
    },
  },

  methods: {
    copyInitialPrice() {
      this.bid.package[
        this.bidServiceType
      ].data.actual_contract_sum = this.bid.package[
        this.bidServiceType
      ].data.initial_contract_sum;
    },
    closeDeclineModal() {
      this.declineDialogModel = false;
      this.commentDecline = null;
    },

    toggleDecline(force) {
      if (!this.bid.is_decline && force !== true) {
        this.declineDialogModel = true;
        return;
      }

      this.loadingDecline = true;
      const url = `v1/verificator/bids/${this.bid.id}/toggle-decline`;
      apiCallTrue({
        url,
        method: "POST",
        data: {
          message: this.commentDecline,
          new_state: !this.bid.is_decline ? 1 : 0,
        },
      })
        .then((response) => {
          if (response.data.data.message) {
            showNotify("error", response.data.data.message);
          }
          this.bid.is_decline = response.data.data.bid.is_decline;
          this.bid.decline = response.data.data.bid.decline;
          this.closeDeclineModal();
        })
        .catch((error) => {
          showNotify("error", error);
          if (error.validation) {
            this.errors = error.validation;
            console.log("SSSSS", this.errors);
            this.errorMessages = this.errors;
          } else {
            this.errors = {};
            this.errors.message = error.message;
          }
        })
        .finally(() => {
          this.loadingDecline = false;
        });
    },

    async returnBid() {
      this.isLoaded = true;
      apiCallTrue({
        url: `v1/verificator/bids/${this.bid.id}/rollback`,
      })
        .then(() => {
          this.$emit("refreshBid");
          window.location.reload();
        })
        .finally(() => {
          this.isLoaded = false;
        });
    },

    getStatusName(item) {
      if (item.is_decline === true) {
        return `Отказ: ${item.decline.message}`;
      }
      return this.statusNames[item.status].name
        ? this.statusNames[item.status].name
        : "";
    },

    getDateRange() {
      if (
        this.bid.package[this.bidServiceType].data.date_from &&
        this.bid.package[this.bidServiceType].data.date_to
      ) {
        const date_from = new Date(
          this.bid.package[this.bidServiceType].data.date_from
        );
        const date_to = new Date(
          this.bid.package[this.bidServiceType].data.date_to
        );

        const serviceRange = Math.ceil(
          Math.abs(date_to.getTime() - date_from.getTime()) / (1000 * 3600 * 24)
        );

        this.serviceRange = isNaN(serviceRange) ? "-" : serviceRange;
      }
      return "";
    },

    getDateFrom(date) {
      moment.locale(i18n.locale);
      const now = new Date().toISOString().substr(0, 19);
      return moment(date).from(now);
    },
  },
  created() {
    if (this.bid.type === 5 || this.bid.type === 7) {
      this.bidServiceType = "bankKik";
    }
  },
  mounted() {
    this.getDateRange();
  },
};
</script>
<style lang="scss">
.service {
  &__item {
    margin: 0;
    color: #aaa;
    & + .service__item {
      margin-left: 60px;
    }

    &.active {
      color: #000;

      .service__icon svg path {
        fill: #000;
      }
    }
    h2 {
      text-align: center;
    }
  }
  &__icon {
    max-width: 50px;
    max-height: 50px;
    margin: 0 auto;

    svg {
      display: block;
      width: 100%;
      height: 100%;

      path {
        fill: #aaa;
      }
    }
  }
}
.bid {
  // &__create {
  //     text-align: center;
  //     padding: 40px 0 !important;

  //     &-tender {
  //         margin-top: 40px !important;

  //         &::before {
  //             content: '';
  //             display: block;
  //             width: calc(100% - 60px);
  //             height: 1px;
  //             background: #dadada;
  //             margin: 0 auto 40px;
  //         }
  //     }
  // }
  // &__tender-content {
  //     border: 1px solid #aaa;
  //     max-width: 700px;
  //     margin: 0 auto !important;
  //     display: block;
  // }
  &__info {
    &-title {
      color: #aaa;
    }
    &-content {
      font-weight: 700;

      span {
        font-size: 13px;
        font-weight: 400;
        font-style: italic;
        text-decoration: underline;
        color: #aaa;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  &__return-link {
    strong {
      // font-style: italic;
      color: #ff0000;
      text-decoration: underline;
      margin-left: 5px;
      cursor: pointer;
    }
  }
  &__agreement {
    padding: 24px 0 8px;

    &-link {
      color: #404ce6;
      text-decoration: underline;
      font-size: 14px;
      cursor: pointer;
    }
    &-info {
      text-align: left;
      h3 {
        margin: 16px 24px;
      }
      p {
        margin: 16px 24px;
      }
      ol {
        // list-style: none;
        margin: 0 0 48px 36px;
      }
      li {
        & + li {
          margin-top: 16px;
        }
      }
    }
    &-confirm {
      text-align: center;
    }
  }
}
.divider {
  display: block;
  width: 100%;
  height: 1px;
  background: #ccc;
  margin: 16px 0;
}
</style>
